import {del, get, getResponse, patch, post, put} from '../../../Core/Request.js';

export const getTemplateName = (pollId) => get(`/polls/${pollId}/name`);
export const savePoll = (pollId, data) => put(`/polls/${pollId}/name`, data);
export const savePollDescription = (pollId, data) => put(`/polls/${pollId}/description`, data);
export const copyTemplate = (pollId) => put(`/polls/${pollId}/copy`);
export const deletePoll = (pollId) => del(`/polls/${pollId}/`);

/**
 * Maps the response that uses ISO Dates to use timestamps instead to not break the rest of the app
 * @type {API.ResponseTransformer<API.Poll>}
 */
const transformPollDates = (poll) => {
    if (poll.startedAt) poll.startedAt = new Date(poll.startedAt).getTime() / 1000;
    if (poll.createdAt) poll.createdAt = new Date(poll.createdAt).getTime() / 1000;
    if (poll.closedAt) poll.closedAt = new Date(poll.closedAt).getTime() / 1000;
    if (poll.modifiedAt) poll.modifiedAt = new Date(poll.modifiedAt).getTime() / 1000;
    if (poll.settings?.nextStartAt) poll.settings.nextStartAt = new Date(poll.settings.nextStartAt).getTime() / 1000;
    if (poll.settings?.nextStopAt) poll.settings.nextStopAt = new Date(poll.settings.nextStopAt).getTime() / 1000;
    if (poll.state?.lastActivityAt) poll.state.lastActivityAt = new Date(poll.state.lastActivityAt).getTime() / 1000;
    return poll;
};

/**
 * @type {PollQuery}
 * @param pollId
 */
export const getPollById = (pollId, params) =>
    getResponse(`/polls/${pollId}`, params, {transformResponse: [JSON.parse, transformPollDates]})
;
export const getTags = (pollId) => get(`/polls/${pollId}/tags`);
export const getAvailableTags = (pollId) => get(`/polls/${pollId}/tags/available`);
export const addTagToPoll = (pollId, tagId) => post(`/polls/${pollId}/tags/${tagId}/`);
export const removeTagFromPoll = (pollId, tagId) => del(`/polls/${pollId}/tags/${tagId}/`);

export const getPollPasswords = (pollId) => get(`/polls/${pollId}/policies/passwords`);
export const savePollPasswords = (pollId, data) => put(`/polls/${pollId}/policies/passwords`, data);

export const getPollPrivacyPolicy = (pollId) => get(`/polls/${pollId}/policies/privacy`);
export const savePollPrivacyPolicy = (pollId, data) => put(`/polls/${pollId}/policies/privacy`, data);

export const getPollAccessPolicy = (pollId) => get(`/polls/${pollId}/policies/access`);
export const savePollAccessPolicy = (pollId, data) => put(`/polls/${pollId}/policies/access`, data);

export const getPollWhiteList = (pollId) => get(`/polls/${pollId}/policies/whitelist`);
export const savePollWhiteList = (pollId, data) => put(`/polls/${pollId}/policies/whitelist`, data);

export const getPollBlackList = (pollId) => get(`/polls/${pollId}/policies/blacklist`);
export const savePollBlackList = (pollId, data) => put(`/polls/${pollId}/policies/blacklist`, data);

export const getPollIframeSettings = (pollId) => get(`/polls/${pollId}/policies/iframe`);
export const savePollIframeSettings = (pollId, data) => put(`/polls/${pollId}/policies/iframe`, data);

export const getPollAccessKeys = (pollId) => get(`/polls/${pollId}/accesskeys`);
export const getFreePollAccessKeys = (pollId) => get(`/polls/${pollId}/accesskeys/free`);
export const getUsedPollAccessKeys = (pollId) => get(`/polls/${pollId}/accesskeys/used`);
export const getPollAccessKeysInfo = (pollId) => get(`/polls/${pollId}/accesskeys/info`);
export const generatePollAccessKeys = (pollId, numKeys) => put(`/polls/${pollId}/accesskeys`, numKeys);
export const deletePollAccessKeys = (pollId) => del(`/polls/${pollId}/accesskeys/free`);

export const savePollSchedule = (pollId, data) => put(`/polls/${pollId}/schedule`, data);
export const startPoll = (pollId) => put(`/polls/${pollId}/start`);
export const stopPoll = (pollId) => put(`/polls/${pollId}/stop`);
export const restartPoll = (pollId) => put(`/polls/${pollId}/reset`);
export const fetchMonitoringJobs = (pollId) => get(`/polls/${pollId}/reportJobs`);
export const createMonitoringJob = (pollId, data) => post(`/polls/${pollId}/reportJobs`, data);
export const patchMonitoringJob = (pollId, reportJobId, data) => patch(`/polls/${pollId}/reportJobs/${reportJobId}`, data);
export const deleteReportJobs = (pollId, reportJobId) => del(`/polls/${pollId}/reportJobs/${reportJobId}`);

export const createPoll = (data) => post(`/polls/`, data);
export const getPolls = ({limit, search = null, offset = 0, order = 'desc', sort = 'lastActivityAt'}) =>
    get("/polls/", {limit, offset, order, sort, search});


/**
 * @type {PollsQuery}
 */
export const loadPolls = (searchparams) =>
    getResponse(`/polls`, searchparams, {transformResponse: [JSON.parse, arr => arr.map(transformPollDates)]});

export const confirmPollShare = (data) => post(`/polls/sharelink/use`, data);

export const getNewName = (data) => get(`/polls/name`, data);
export const clonePoll = (pollId, data) => post(`/polls/${pollId}/`, data);
export const sharePoll = (pollId, data) => post(`/polls/${pollId}/sharelink/send`, data);
export const deleteImage = (pollId, file) => del(`/polls/${pollId}/images`, {file});
export const deleteVideo = (pollId, file) => del(`/polls/${pollId}/videos`, {file});
export const deleteDocument = (pollId, file) => del(`/polls/${pollId}/documents`, {file});
export const fetchLanguagesList = (): Promise<{ LanguageCode: string }[]> => get('/polls/languages');
export const savePollTheme = (pollId, data) => put(`/polls/${pollId}/layout/theme`, data);
export const uploadPollLogo = (pollId, data) => put(`/polls/${pollId}/logo`, data);

export const fetchPollStatistics = (pollId, params) => get(`/polls/${pollId}/statistics`, params);
export const fetchPollQuestions = (pollId, lang = null) => get(`polls/${pollId}/questions${lang ? `?lang=${lang}` : ''}`);
export const fetchQuestion = (pollId, questionId, lang = null) => get(`polls/${pollId}/questions/${questionId}${lang ? `?lang=${lang}` : ''}`);


